import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { EntityTabs } from '../../../constants/entity-tabs';

const useEntityTabs = ({ refetch, overview }) => {
  const { state } = useLocation();

  const [tab, setTab] = useState(state?.tabNumber || EntityTabs.Accommodation);

  const handleChangeTab = (event, newTab) => {
    setTab(newTab);
    refetch();
  };

  const Tabs = [
    {
      title: 'Accommodations',
      overview: overview.accommodations,
      tabIndex: EntityTabs.Accommodation
    },
    {
      title: 'Activities',
      overview: overview.activities,
      tabIndex: EntityTabs.Activities
    },
    {
      title: 'Rental Items',
      overview: overview.rental,
      tabIndex: EntityTabs.Rental
    }
  ];

  return { tab, handleChangeTab, Tabs };
};

export default useEntityTabs;
